export const UPDATE_ACCOUNTDETAILS_TAB_INDEX = 'UPDATE_ACCOUNTDETAILS_TAB_INDEX';
export const SET_FMO_DETAILS = 'SET_FMO_DETAILS';
export const SET_FMO_SERVICE_IN_PROGRESS = 'SET_FMO_SERVICE_IN_PROGRESS';
export const REQUEST_PRODUCER_DETAILS_DATA = 'REQUEST_CLIENTS_DATA';
export const RECEIVE_PRODUCER_DETAILS_DATA = 'RECEIVE_CLIENTS_DATA';
export const PRODUCER_DETAILS_SERVICE_ERROR = 'CLIENTS_SERVICE_ERROR';
export const BULKUPLOAD_OUTPUT_REQUEST = 'BULKUPLOAD_OUTPUT_REQUEST';
export const SET_PRINCIPAL_USER_DETAILS = 'SET_PRINCIPAL_USER_DETAILS';
export const UPDATE_APPOINTMENT_TAB_INDEX='UPDATE_APPOINTMENT_TAB_INDEX';
export const SET_FMO_OR_PPA_AGENCY_STATUS = 'SET_FMO_OR_PPA_AGENCY_STATUS ';
export const ALLOWED_AGENCY_DETAILS_DATA = 'ALLOWED_AGENCY_DETAILS_DATA';
export const RECEIVE_PRINCIPAL_PRODUCER_DETAILS_DATA = 'RECEIVE_PRINCIPAL_PRODUCER_DETAILS_DATA';
export const PRINCIPAL_ASSOCIATED_WITH_FMO = 'PRINCIPAL_ASSOCIATED_WITH_FMO';
export const PRINCIPAL_ASSOCIATED_WITH_FMO_DETAILS = 'PRINCIPAL_ASSOCIATED_WITH_FMO_DETAILS';
export const CONTACT_UPDATE_CAMPAIGN_DETAILS = 'CONTACT_UPDATE_CAMPAIGN_DETAILS';
export const CONTACT_CONFIRMED = 'CONTACT_CONFIRMED';